export default __webpack_public_path__ + "static/media/Mountaineering.55cd1e95.svg";